// extracted by mini-css-extract-plugin
export default {"InputGroup":"InputGroupe2EvBGz2cnqy","InputGroup_no-separators":"InputGroup_no-separators1ntMvFrjMlUs"};